import {apiFetch} from "../client";

// Невзятые заявки, которые площадка закрыла и оплатила кабинету, а мы не
// разнесли. Источник правды по телам — internal/extsource/platform_closed_handler.go.
//
// Все суммы приходят строками и такими же остаются. У денег четыре знака на
// стороне площадки и шесть на нашей, и перевод в JS-число потерял бы младшие
// ровно там, где стоит вся задача.

/** Одна такая заявка. */
export interface PlatformClosedOrderItem {
    source: string;
    /** Их id заявки. Строка, а не число: id площадки в JSON нам не считать. */
    externalId: string;
    orderId: string;
    accountCode: string;
    /** Когда площадка расплатилась с кабинетом. */
    paidAt: string;
    /** Сумма выплаты в USDT — то, что площадка отдала кабинету за эту заявку. */
    amount: string;
    /** Строки книги, из которых сложилась сумма: их можно открыть у площадки. */
    bookRows: string[];
    /**
     * Ключ, которым проводка ляжет в леджер. Показывается ДО нажатия: это тот же
     * ключ, который печатают алерты сверки, и по нему проводку потом находят.
     */
    correctionKey: string;
}

export interface PlatformClosedOrdersResponse {
    orders: PlatformClosedOrderItem[];
    total: string;
    currency: string;
}

/** GET /v1/merchant/{id}/platform-closed-orders — admin-only. */
export function getPlatformClosedOrders(
    token: string | null,
    merchantId: string,
): Promise<PlatformClosedOrdersResponse> {
    return apiFetch<PlatformClosedOrdersResponse>(
        `/merchant/${encodeURIComponent(merchantId)}/platform-closed-orders`,
        token,
    );
}

export interface SettlePlatformClosedOrderResponse {
    order: PlatformClosedOrderItem;
    teamId: string;
    teamName: string;
    merchantName: string;
    currency: string;
    teamOperationKeys: string[];
}

/**
 * POST /v1/merchant/{id}/platform-closed-orders/{externalId}/settle.
 *
 * Команду называет человек, и поля по умолчанию у неё нет: система не знает,
 * кто выполнил заявку в кабинете площадки.
 */
export function settlePlatformClosedOrder(
    token: string | null,
    merchantId: string,
    externalId: string,
    teamId: string,
): Promise<SettlePlatformClosedOrderResponse> {
    return apiFetch<SettlePlatformClosedOrderResponse>(
        `/merchant/${encodeURIComponent(merchantId)}/platform-closed-orders/${encodeURIComponent(externalId)}/settle`,
        token,
        {method: "POST", body: JSON.stringify({teamId})},
    );
}
